import { useState } from "react";
import "./CardCarousel.css";
import photo1 from '../images/img1.jpeg';
import photo2 from '../images/WhatsApp Image 2026-02-05 at 12.15.39 (2).jpeg';
import photo3 from '../images/WhatsApp Image 2026-02-05 at 12.15.40.jpeg';
import photo4 from '../images/WhatsApp Image 2026-02-05 at 12.15.40 (1).jpeg';
import photo5 from '../images/WhatsApp Image 2026-02-05 at 12.15.40 (2).jpeg';
import photo6 from '../images/WhatsApp Image 2026-02-05 at 12.15.40 (3).jpeg';
import photo7 from '../images/WhatsApp Image 2026-02-05 at 12.15.40 (4).jpeg';
import photo8 from '../images/WhatsApp Image 2026-02-05 at 12.15.41.jpeg';

const CardCarousel = ({ onNext, onBack }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [flippedCards, setFlippedCards] = useState(new Set());

  const cards = [
    {
      letter: "I",
      paragraph: "I see you in every sunrise, feel you in every heartbeat. You are the light that guides me through every day, the reason my world feels complete. In you, I found my home, my peace, my everything."
    },
    {
      letter: "L",
      paragraph: "Love isn't just a word—it's the way you make me feel, the way you understand me without words, the way you make ordinary moments extraordinary. Loving you is the easiest and most beautiful thing I've ever done."
    },
    {
      letter: "O",
      paragraph: "Only you could make me believe in forever. Only you could turn my world into a place of endless wonder. You are the one my heart chose, the one my soul recognizes, the one I want to share every tomorrow with."
    },
    {
      letter: "V",
      paragraph: "Valentine's Day is just one day, but you make every day feel like Valentine's. You are my greatest gift, my most precious treasure. With you, every moment is a celebration of love."
    },
    {
      letter: "E",
      paragraph: "Every smile you give me, every laugh we share, every quiet moment together—these are the memories I cherish most. You've shown me that love isn't about grand gestures, but about the beautiful everyday moments we create together."
    },
    {
      letter: "Y",
      paragraph: "You are my favorite person, my best friend, my greatest love. You've changed my life in ways I never imagined possible. With you, I've learned that love is patient, kind, and absolutely magical."
    },
    {
      letter: "O",
      paragraph: "Our story is still being written, and I can't wait to see what beautiful chapters lie ahead. Together, we've created something special, something real, something that will last forever."
    },
    {
      letter: "U",
      paragraph: "Us—that's my favorite word. Because 'us' means you and me, together, facing the world hand in hand. You complete me in ways I never knew I needed. Thank you for being you, for being mine, for being us."
    }
  ];

  const handleCardClick = (index) => {
    const newFlipped = new Set(flippedCards);
    if (newFlipped.has(index)) {
      newFlipped.delete(index);
    } else {
      newFlipped.add(index);
    }
    setFlippedCards(newFlipped);
  };

  const nextCard = () => {
    if (currentIndex < cards.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      onNext();
    }
  };

  const prevCard = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Replace with your actual photo paths
  const cardPhotos = [
    photo1,
    photo2,
    photo3,
    photo4,
    photo5,
    photo6,
    photo7,
    photo8
  ];

  return (
    <section className="card-carousel-section">
      <div className="carousel-container">
        <div className="carousel-header">
          {currentIndex === 0 && (
            <button className="btn-secondary header-back-btn" onClick={onBack}>
              ← Back
            </button>
          )}
          <h2 className="section-title">I L O V E Y O U</h2>
          <p className="card-counter">{currentIndex + 1} / {cards.length}</p>
        </div>

        <div className="card-wrapper">
          {cards.map((card, index) => (
            <div
              key={index}
              className={`flip-card ${flippedCards.has(index) ? "flipped" : ""} ${index === currentIndex ? "active" : ""}`}
              onClick={() => handleCardClick(index)}
              style={{ 
                display: index === currentIndex ? 'block' : 'none'
              }}
            >
              <div className="card-controls">
                <button 
                  className="nav-btn prev-btn-overlay"
                  onClick={(e) => {
                    e.stopPropagation();
                    prevCard();
                  }}
                  disabled={currentIndex === 0}
                  title="Previous card"
                >
                  ← Prev
                </button>
                <span className="card-counter-overlay">{currentIndex + 1} / {cards.length}</span>
                <button 
                  className="nav-btn next-btn-overlay"
                  onClick={(e) => {
                    e.stopPropagation();
                    nextCard();
                  }}
                  title="Next card"
                >
                  {currentIndex === cards.length - 1 ? "Done →" : "Next →"}
                </button>
              </div>
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <img 
                    src={cardPhotos[index]}
                    alt={`Card ${card.letter}`}
                    className="card-front-image"
                  />
                  <div className="card-image">
                    <div className="image-overlay" />
                    <div className="letter-display">{card.letter}</div>
                    <div className="tap-hint">Tap to reveal</div>
                  </div>
                </div>
                <div className="flip-card-back">
                  <div className="paragraph-content">
                    <div className="letter-badge">{card.letter}</div>
                    <p>{card.paragraph}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="carousel-controls">
          <div className="dot-indicators">
            {cards.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CardCarousel;
